export const isEmail = (maybeEmail: string): boolean => {
  const match = maybeEmail.match(/^[^@\s]+@[^@\s]+\.[^@\s]+$/);
  return !!match && match.length > 0;
};
